import React, { useEffect , }  from 'react' 
import  {LinkContainer}  from 'react-router-bootstrap'

import {Table, Button, Container } from 'react-bootstrap'

import { useDispatch, useSelector } from 'react-redux'

import Message from '../../Message/Message' 
import Loader from '../../Loader/Loader' 

import { listNewsflashs , deleteNewsflashs }  from '../../../actions/newsflashActions'

const NewsflashList = ({ history }) => {

    const dispatch = useDispatch()

    const newsflashList = useSelector(state => state.newsflashList)
    const { loading, error, newsflashs } = newsflashList

    const newsflashRegister = useSelector(state => state.newsflashRegister)
    const { newsflashInfo } = newsflashRegister

    const newsflashDelete = useSelector(state => state.newsflashDelete)
    const { success: successDelete } = newsflashDelete

   

    useEffect(() => {
     (newsflashInfo) && dispatch(listNewsflashs())
  
    }, [dispatch, successDelete, newsflashInfo])

    const deleteHandler = (id) => {
        if (window.confirm('Are you sure')) {
            dispatch(deleteNewsflashs(id))
        }
    }


  //      const goBack = () => {
    //    history.goBack(); // This function navigates back to the previous page
     //   };



    return (
        <div  >
          

            <Container>
            <LinkContainer style={{ float: 'right',  backgroundColor: 'red'  }}   to="/newsflashadd">
                <Button style={{  backgroundColor: 'red'  }} className="mr-3 mb-3"> ajouter un News-flash </Button>
            </LinkContainer>
                {loading ? <Loader/>
                    : error ? <Message variant='danger'>{error}</Message>
                        : (
                            <div class="table-responsive text-nowrap">
                           <Table    responsive    class="table table-striped" >
                                <thead>
                                    <tr>
                                         <th>Titre</th>
                                         <th>Description</th>
                                         <th>link </th>
                                        
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        newsflashs.map(newsflash => (
                                            <tr key={newsflash._id}>
                                                <td>{newsflash.titre}</td>
                                                <td>{newsflash.text}</td>
                                                <td>{newsflash.link}</td>
                                             
                                                <td>
                                                    <LinkContainer to={`/admin/newsflash/${newsflash._id}/edit`}>
                                                        <Button variant="light" className="btn btn-sm">
                                                            <i className="fas fa-edit"></i>
                                                        </Button>
                                                    </LinkContainer>

                                                
                                                    
                                                    <Button
                                                        variant="danger"
                                                        className="btn-sm mr-2"
                                                        onClick={() => deleteHandler(newsflash._id)}
                                                    >
                                                        <i className="fas fa-trash-alt"></i>
                                                    </Button>
                                                </td>
                                            </tr>
                                        ))
                                    }
                                </tbody>
                            </Table>
                        </div>
                        )
                }
            </Container>
        </div>
    )
}

export default NewsflashList
